<!-- 补差价 -->
<template>
  <div class="fillPriceDifference cus-modal" v-loading="loading">
    <OmsForm :form-config="formConfig" />
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>

<script>

export default {
  name: 'fillPriceDifference',
  props: {
    componentData: {},
  },
  data() {
    return {
      disabled: false,
      ID: this.$route.params.customizedModuleId && (this.$route.params.customizedModuleId.toUpperCase() != 'NEW') ? this.$route.params.customizedModuleId : '-1',
      loading: false,
      btnConfig: {
        typeAll: 'default',
        btnsite: 'right',
        buttons: [
          {
            text: '返回', // 取消
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            },
          },
          {
            type: 'primary', // 按钮类型
            text: $it('com.determine'), // 确定 按钮文本
            btnclick: () => {
              this.datermine();
            } // 按钮点击事件
          }
        ],
      },
      formConfig: {
        formValue: {
          REISSUE_BILL_NO: '',
          REISSUE_AMT: '',
          REISSUE_BILL_CODE: '',
          REMARK: ''
        },
        formData: [
          {
            style: 'input',
            label: '补差单号',
            value: 'REISSUE_BILL_NO',
            width: '24',
            placeholder: '请录入OM单号并回车！',
            inputenter: () => {
              this.getPrice()
            }, // 表单回车事件
          },
          {
            style: 'input',
            label: '补差金额',
            value: 'REISSUE_AMT',
            width: '24',
            disabled: true
          },
          {
            style: 'input',
            label: '补发订单编号',
            value: 'REISSUE_BILL_CODE',
            width: '24',
          },
          {
            style: 'input',
            label: $it('tL.remarks'), // 备注
            value: 'REMARK',
            width: '24',
          }
        ],
        ruleValidate: {
          REISSUE_BILL_NO: [{ required: true, message: ' ', trigger: 'blur' }],
        }
      }
    };
  },
  mounted() {

  },
  methods: {
    async datermine() {
      const { REISSUE_BILL_NO, REISSUE_AMT } = this.formConfig.formValue
      if (REISSUE_BILL_NO == '' || REISSUE_AMT === '') {
        return $fcError('请录入OM单号并回车!')
      }
      const { ID } = this.componentData.data.order
      let params = {
        OC_B_ORDER_ID: ID,
        ...this.formConfig.formValue
      }
      this.loading = true;
      const { data: { code, message } } = await this.service.orderCenter.makeUpDiffPriceConfirm(params);
      this.loading = false;
      if (code === 0) {
        this.$parent.$parent.closeConfirm();
        this.$Message.success(message)
      }
    },
    async getPrice() {
      const { ID } = this.componentData.data.order
      const { REISSUE_BILL_NO } = this.formConfig.formValue
      let params = {
        OC_B_ORDER_ID: ID,
        REISSUE_BILL_NO
      }
      this.loading = true;
      const { data: { code, data } } = await this.service.orderCenter.makeUpDiffPriceGetPrice(params);
      this.loading = false;
      if (code === 0) {
        const { REISSUE_AMT, REISSUE_BILL_NO, CODE } = data
        const handler = () => {
          this.formConfig.formValue = {
            ...this.formConfig.formValue,
            REISSUE_AMT,
            REISSUE_BILL_NO
          }
        }
        if (CODE == 1) { // 1：正常 2：需要弹出是否继续框并提示
          handler()
        } else {
          this.$Modal.info({
            className: 'ark-dialog',
            title: $it('mT.tips'), // 提示
            content: `补差单号：${REISSUE_BILL_NO}, 已绑定其他订单，是否继续？`,
            mask: true,
            showCancel: true,
            onOk: () => {
              handler()
            },
          });
        }
      }
    }
  },
};
</script>
<style lang="less" scoped>
// 英文字母大写
/deep/ input::-webkit-input-placeholder {
  text-transform: uppercase !important;
}
</style>